import Record from './Record'

export default class Company extends Record {

	constructor (data) {
		super(data)

		if (typeof data.nav_tech_user === 'object' && data.nav_tech_user !== null) {
			data.nav_tech_user = new Record(data.nav_tech_user)
		} else {
			data.nav_tech_user = new Record({})
		}

		return this._proxy
	}

	static async fetch (id = null) {
		if (id == null) {

			// Create record
			return new Company({
				id: null,
				uuid: await Anvil.REST.get('/util/uuid'),
				group_id: null,

				name: '',
				phone: '',
				email: '',

				tax_number: '',

				invoice_area_code: '',
				invoice_city: '',
				invoice_address: '',

				service_partner: 0,		// ez a cég pénztárgépszerviz

				distributor: 0,			// ez a cég disztribútor
				distributor_id: 145,	// ennek a cégnek a disztríbútora

				referer: 0,				// ez a cég ajánló
				referer_id: null,		// ennek a cégnek az ajánlója

				invoicing_period: 'monthly',
				nav_tech_user: null,

				tags: []
			})
		} else {
			// Load
			let data = await Anvil.REST.get(`/company/${id}`)
			return new Company(data)
		}
	}

	static async delete (id) {
		await Anvil.REST.delete(`/company/${id}`)
	}

	async commit () {
		if (this._data.id == null) {
			// Insert
			const res = await Anvil.REST.post(`/company`, this._data)
			this._data.id = res.insertId
		} else {
			// Update
			await Anvil.REST.put(`/company/${this._data.id}`, this._data)
		}
	}
}
